export enum ShippingDirection {
    INBOUND = 'INBOUND',
    OUTBOUND = 'OUTBOUND',
}
